import { getPlatform } from '@/core/settings/utils';
import { useProductB2BPriceAdvantageQuery } from '@/domains/productDiscovery/ProductPage/b2b/queries/generated/b2bPriceAdvantage.query.generated';
import { type Platform } from '@/generated/graphql/types';

export const useB2bPriceAdvantage = (
  modelId: string | number,
): number | null => {
  const platform = getPlatform().toUpperCase() as Platform;

  const [{ data }] = useProductB2BPriceAdvantageQuery({
    variables: { modelId, platform },
  });

  return data?.priceAdvantage?.amountSavedPercentage ?? null;
};
